"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SliderFormControl;

var _react = require("@chakra-ui/react");

var _react2 = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SliderFormControl(props) {
  var label = props.label,
      value = props.value,
      isDisabled = props.isDisabled,
      min = props.min,
      max = props.max,
      step = props.step,
      onChange = props.onChange,
      error = props.error;
  return /*#__PURE__*/_react2.default.createElement(_react.FormControl, {
    isInvalid: !!error
  }, /*#__PURE__*/_react2.default.createElement(_react.FormLabel, null, label), /*#__PURE__*/_react2.default.createElement(_react.Slider, {
    value: value,
    isDisabled: isDisabled,
    min: min,
    max: max,
    step: step,
    onChange: onChange
  }, /*#__PURE__*/_react2.default.createElement(_react.SliderTrack, null, /*#__PURE__*/_react2.default.createElement(_react.SliderFilledTrack, {
    bg: error ? "orange.100" : "blue.500"
  })), /*#__PURE__*/_react2.default.createElement(_react.SliderThumb, {
    padding: 3,
    bg: error ? "orange.100" : "white"
  }, value)), error ? /*#__PURE__*/_react2.default.createElement(_react.FormErrorMessage, {
    textColor: "orange.500"
  }, error) : null);
}